<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-stock-movement-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalStockMovement"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-stock-movement-modal"
      data-bs-dismiss="modal"
      data-bs-target="#modalStockMovement"
    ></button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div
      class="modal fade"
      id="modalStockMovement"
      tabindex="-1"
      aria-labelledby="modalStockMovementLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div class="d-flex align-items-center">
              <h5 class="modal-title">Stock Movement</h5>
              <div
                class="d-flex align-items-center"
                v-if="itemSelect?.item_no || itemSelect?.item_name"
              >
                <div class="mx-3">-</div>
                <h5 class="modal-title mb-0">
                  <span v-if="itemSelect.item_no" style="color: #007bff">
                    {{ itemSelect.item_no }}</span
                  ><span
                    :class="itemSelect.item_no ? 'ms-3' : ''"
                    v-if="itemSelect.item_name"
                    style="color: #007bff"
                  >
                    {{ itemSelect.item_name }}</span
                  >
                </h5>
              </div>
            </div>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              >clear</i
            >
          </div>
          <div class="modal-body mb-3">
            <div class="row justify-content-end">
              <div class="col-lg-4 col-12 d-flex align-items-center justify-content-center">
                <label class="fw-bold mb-0 me-3">Outlet</label>
                <Multiselect
                  v-model="physicalBranchSelected"
                  :options="physicalBranches"
                  :canClear="false"
                  placeholder="Branch"
                  @change="changeBranch"
                />
              </div>
              <div class="col-lg-4 col-12 d-flex align-items-center justify-content-center">
                <label class="fw-bold mb-0 me-3">Period</label>
                <Multiselect
                  v-model="timeType"
                  :options="timeTypes"
                  :canClear="false"
                  placeholder="Select Time"
                  @update:model-value="getList(page)"
                />
              </div>
              <div class="col-lg-2 col-12 d-flex align-items-center justify-content-center">
                <!-- <material-button
                  @click="exportFile('excel')"
                  class="btn btn-sm btn-background mw-185px ms-3"
                >
                  Export
                </material-button> -->
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle btn-sm mb-0"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                  >{{ $t('download') }}</button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <!-- <li>
                      <a class="dropdown-item" @click="exportFile('csv')" href="#">Export CSV</a>
                    </li> -->
                    <li>
                      <a class="dropdown-item" @click="exportFile('xlsx')" href="#">Export Excel</a>
                    </li>
                    <li>
                      <a class="dropdown-item" @click="exportFile('pdf')" href="#">Export PDF</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="table-responsive p-0 custom-table mt-5">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-left font-weight-bolder"
                      v-for="(column, index) in columns"
                      :key="index"
                      :class="{ 'text-center': index === 5 }"
                    >
                      {{ column }}
                    </th>
                  </tr>
                </thead>
                <tbody v-if="stockMovement.length > 0">
                  <tr v-for="(value, index) in stockMovement" :key="index">
                    <td class="text-left text-xss w-13">
                      {{ value.created_at_format }}
                    </td>
                    <td class="text-left text-xss w-12">
                      {{ value.movement_type_label }}
                    </td>
                    <td class="text-left text-xss w-10">
                      {{ value.physical_branch_name }}
                    </td>
                    <td class="text-left text-xss w-10">{{ value.item_no }}</td>
                    <td class="text-left text-xss w-25">
                      {{ value.item_name }}
                    </td>
                    <td class="text-center text-xss w-10">
                      {{ value.qty_change }}
                    </td>
                    <td class="text-left text-xss w-10 cursor-pointer" @click="getStockTransferDetail(value.stock_transfer_id)">{{ value.ref_no }}</td>
                    <td class="text-left text-xss w-10">{{ value.notes }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8" class="text-center">No item available</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="modal-footer flex-column justify-content-end"
            v-if="pagination.last_page > 1"
          >
            <div class="w-100">
              <pagination
                :pagination="pagination"
                :current_page="pagination.current_page"
                :last_page="pagination.last_page"
                class="mx-2 mb-3"
                style="padding: 0 !important"
              />
            </div>
          </div>
        </div>
        <material-loading :active="loaderActive" />
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-2 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <ModalItemList
      :keyReload="keyReloadStockTransferDetail"
      :stockTransferDetail="stockTransferDetail"
      :fromStockMovement="true"
    />
    <form
      :action="`${actionDownload}/merchant/inventory/item/${itemId}/stock-movement/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="list_field_show" :value="columnShowed" />
      <input type="hidden" name="physical_branch_id" :value="physicalBranchSelected" />
      <input type="hidden" name="time_type" :value="timeType" />
      <input type="hidden" name="item_id" :value="itemId" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import { formatPrice } from "@/config/utils";
import { STATUS_IN_TRANSIT, STATUS_VOID } from "../mock_data";
import InventoryService from "@/services/inventory.service";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Pagination from "@/components/Pagination.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "@vueform/multiselect/themes/default.css";
import "@vuepic/vue-datepicker/dist/main.css";
import CommonFunctionService from "../../../services/commonFunction.service";
import ModalItemList from "./ModalItemList.vue";
import moment from 'moment';
import "bootstrap/dist/js/bootstrap.bundle";
import Modal from "bootstrap/js/dist/modal";
// import MaterialButton from "@/components/MaterialButton.vue";
import TokenService from "../../../services/token.service";
import $ from "jquery";

export default {
  name: "ModalStockMovement",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    Pagination,
    Multiselect,
    ModalItemList,
    // MaterialButton,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
    itemSelect: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      action_export: "excel",
      loaderActive: false,
      snackbar: null,
      message: "",
      columns: [
        "Date & Time",
        "Movement Type",
        "Outlet",
        "Item No",
        "Item Name",
        "Qty Change",
        "Ref No.",
        "Notes",
      ],
      STATUS_IN_TRANSIT,
      STATUS_VOID,
      stockMovement: [],
      pagination: {},
      page: 1,
      physicalBranches: [],
      physicalBranchSelected: 0,
      keyReloadStockTransferDetail: "keyReloadStockTransferDetail",
      stockTransferDetail: null,
      timeTypes: [
        { label: "Last 7 days", value: 1 },
        { label: "Last 30 days", value: 2 },
        { label: "Last 3 months", value: 3 },
        { label: "This year", value: 4 },
      ],
      timeType: 1,
    };
  },
  methods: {
    formatPrice,

    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    dateFormat(date) {
      if (date == null) {
        return null
      } else {
        return moment(date).format('YYYY-MM-DD')
      }
    },

    changeBranch(value) {
      this.physicalBranchSelected = value;
      this.getList(this.page);
    },

    async getDataFilter() {
      this.showLoader();
      var dataForm = {
        get_physical_branches: 1,
      };

      await InventoryService.getDataFilter(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.physicalBranches = data.physical_branches;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    getList(page) {
      this.showLoader();

      var dataForm = {
        page: page,
        item_id: this.itemId,
        physical_branch_id: this.physicalBranchSelected,
        time_type: this.timeType,
      };

      InventoryService.getStockMovementByItem(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.stockMovement = data.items;
            this.pagination = data;
            this.page = this.pagination.current_page;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    async getStockTransferDetail(stockTransferId) {
      this.stockTransferDetail = null;
      this.showLoader();
      var dataForm = {
        id: stockTransferId,
      };

      await InventoryService.getDetailStockTransfer(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.stockTransferDetail = data.stock_transfer;
            this.stockTransferDetail.stock_transfer_items = data.items_selected;
            
            this.showTransferDetailModal();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    showTransferDetailModal() {
      const overlay = document.getElementById("custom-overlay");
      overlay?.classList.add("show");
      const modalElement = document.getElementById("modalStockTransferDetail");
      if (modalElement) {
        const modal = new Modal(modalElement);
        modal.show();
        modalElement.addEventListener("hidden.bs.modal", () => {
          overlay?.classList.remove("show");
        });
      }
    },

    exportFile(type = "excel") {
      this.action_export = type;
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
  watch: {
    keyReload: {
      async handler() {
        this.stockMovement = [];
        this.physicalBranchSelected = 0;
        this.timeType = 1;
        await this.getDataFilter();
        this.getList(this.page);
      },
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 70vw;
}

@media (max-width: 992px) {
  .modal-dialog {
    max-width: 95vw;
  }

  .row .col-lg-4 {
    margin-bottom: 1rem;
  }
}
</style>
